import { ReactElement } from 'react'

export default ({ title }: { title: string }): ReactElement => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>{title}</title>
    <circle cx="19.5" cy="19.5" r="12" stroke="white" strokeOpacity="0.6" strokeWidth="3" />
    <line x1="13" y1="19.5" x2="26" y2="19.5" stroke="white" strokeOpacity="0.6" strokeWidth="3" />
  </svg>
)
